import React, {useState, useEffect} from "react"
import { useStaticQuery, graphql } from "gatsby"
import styled from "styled-components"
import ArticleCategory from "../components/Sections/ArticlesCategory"
import QuoteWidgetForCategory from "../components/Common/QuoteWidgetForCategory"
import PostCard from "../components/Elements/PostCard"
import { categoryClasses, categoryAccentClass } from "../utils/category-classes"
import chunk from "lodash/chunk"
import ArticleSearchBar from "../components/Sections/ArticleSearchBar"

import SEO from "@ifp/gatsby-theme-shared/src/components/SEO/seo"

const SmallBusinessPage = styled.div`
    .title-gap {
        width: 140px;
        height: 4px;
        margin-top: 2rem;
        margin-bottom: 2rem;
    }
    .text-section{
        padding: 3rem 0;
        p{
            margin-bottom: 0;
        }
    }
    .link-list{
        div {
            padding: 1rem;
            margin-bottom: 1rem;
        }
        .button-tertiary{
            @media screen and (max-width: 767px) {
                display: block;
            }
        }
    }
    .border-top {
        border-top: 1px solid #ddd !important;
    }
    section {
        @media (min-width: 992px) {
            padding: 4rem 0;
        }
    }
    .category-list {
        .post-row {
            > div {
                margin-bottom: 1rem;
            }
            &:last-child {
                > div {
                    margin-bottom: 0;
                }
            }
        }
    }
    .post-row {
        margin-bottom: 1rem;
        .post-card-wrapper {
            margin-bottom: 2rem;
        }
    }
`
const PostsRow = styled.div`
    @media (min-width: 450px) {
        display: flex;
        flex-wrap: wrap;
        & > div {
            margin-bottom: 48px;
        }
    }
    @media (min-width: 450px) and (max-width: 767px) {
        & > div {
            width: calc((100% - 24px) / 2);
            &:nth-child(odd) {
                margin-right: 24px;
            }
        }
    }
    @media screen and (min-width: 768px) and (max-width: 1023px) {
        & > div {
            width: calc((100% - 72px) / 4);
            &:not(:last-child) {
                margin-right: 24px;
            }
        }
    }
    @media screen and (min-width: 1024px) {
        & > div {
            width: calc((100% - 126px) / 4);
            margin-bottom: 72px;
            &:not(:last-child) {
                margin-right: 42px;
            }
        }
    }
    @supports (grid-gap: 0) {
        display: -ms-grid;
        display: grid;
        -ms-grid-columns: 1fr;
        grid-template-columns: repeat(1, 1fr);
        grid-gap: 0;
        margin-bottom: 48px;
        & > div {
            width: 100%;
            margin-right: 0;
        }
        @media screen and (min-width: 450px) {
            -ms-grid-columns: 1fr 24px 1fr;
            grid-template-columns: repeat(2, 1fr);
            grid-gap: 24px;
        }
        @media screen and (min-width: 768px) {
            -ms-grid-columns: 1fr 24px 1fr 24px 1fr 24px 1fr;
            grid-template-columns: repeat(4, 1fr);
            grid-gap: 24px;
        }
        @media screen and (min-width: 1024px) {
            margin-bottom: 70px;
            grid-gap: 42px;
        }
    }
`

export default () => {
    const slug = 'small-business';
    const data = useStaticQuery(graphql`
        query SMBQuery{
            allWordpressPost{
                edges {
                    node {
                        title
                        slug
                        excerpt
                        wordpress_id
                        categories {
                            name
                            slug
                        }
                        featured_media {
                            localFile {
                                childImageSharp {
                                    sizes(maxWidth: 400) {
                                        ...GatsbyImageSharpSizes
                                    }
                                }
                            }
                        }
                    }
                }
            }
            wordpressPage(slug: { eq: "small-business" }) {
                title
                slug
                yoast_meta {
                    yoast_wpseo_metadesc
                    yoast_wpseo_title
                }
                acf {
                    ifp_article_page_title
                    ifp_article_page_subtitle
                    ifp_article_categorys {
                        ifp_article_categorys_title
                        ifp_article_categorys_subtitle
                        ifp_article_categorys_type
                        ifp_article_categorys_articles {
                            ifp_article_categorys_articles_url
                        }
                    }
                }
            }
        }
    `);
    const posts = data.allWordpressPost.edges.filter(item=>item.node.categories[0].slug === slug);
    const pageData = data.wordpressPage.acf;
    const {
        ifp_article_page_title,
        ifp_article_page_subtitle,
        ifp_article_categorys
    } = pageData;
    const categorySlug = "uncategorized" && posts[0] && posts[0].node.categories[0].slug;
    const categoryName = "Uncategorized" && posts[0] && posts[0].node.categories[0].name;
    const [postsToShow, setPostsToShow] = useState(12);
    const [isShowAll, setIsShowAll] = useState(false);
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [isShowAll])

    return (
        <SmallBusinessPage>
            <SEO
                title={`${categoryName} | eHealth Resource Center`}
                excerpt={`An archive of every ${categoryName} post we have published`}
                metaDescription={`An archive of every ${categoryName} post we have published`}
                slug={categorySlug}
                pageType="resources"
            />
            <div className="ehi-header--spacer"></div>
            {isShowAll && (<>
                <section className={`${categoryClasses[categorySlug]}`}>
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-xl-8 col-lg-9 text-center">
                                <h2
                                    className="h4"
                                    style={{
                                        opacity: 0,
                                        animation:
                                            "fadeDownSubtle 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                                    }}
                                >
                                    Articles
                                </h2>
                                <h1
                                    className="display-4"
                                    style={{
                                        opacity: 0,
                                        animation:
                                            "scaleDown 1s cubic-bezier(0.215,0.61,0.355,1) forwards",
                                    }}
                                >
                                    {categoryName}
                                </h1>
                                <ArticleSearchBar />
                            </div>
                        </div>
                    </div>
                </section>
                <section className="PostsGallery bg-white pb-xxl">
                    <div className="container container--grid">
                        <div className="container__row">
                            {chunk(posts.slice(0, postsToShow), 4).map(
                                (chunk, i) => (
                                    <PostsRow key={`chunk-${i}`} className="post-row">
                                        {chunk.map(({ node: post }) => (
                                            <PostCard
                                                key={post.wordpress_id}
                                                post={post}
                                                isPost
                                            />
                                        ))}
                                    </PostsRow>
                                )
                            )}
                        </div>
                    </div>
                    {postsToShow < posts.length && (
                        <div className="text-center">
                            <button
                                className="button-tertiary"
                                onClick={() => {
                                    setPostsToShow(postsToShow + 12)
                                }}
                            >
                                Load More
                            </button>
                        </div>
                    )}
                </section>
            </>)}
            {!isShowAll && (
                <>
                    <section className={`${categoryClasses[categorySlug]}`}>
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xl-8 col-lg-9 text-center">
                                    <h1 className="display-4">{ifp_article_page_title ? ifp_article_page_title : `Small Business Health Insurance Articles`}</h1>
                                    <ArticleSearchBar />
                                </div>
                            </div>
                        </div>
                    </section>
                    <section className="bg-white text-section">
                        <div className="container">
                            <div className="row justify-content-center">
                                <div className="col-xl-8 col-lg-9">
                                    <p dangerouslySetInnerHTML={{ __html: ifp_article_page_subtitle ? ifp_article_page_subtitle : 'As a small business owner, there’s a lot to keep in mind when providing health insurance for your employees. Luckily, eHealth’s resource center has all the information you’ll need to navigate the world of small business health insurance and ensure your employees have the coverage they need! <br/><br/>Check out our frequently updated selection of articles from health insurance experts, and reach out to eHealth’s team of licensed health insurance agents if you have more questions!' }}/>
                                </div>
                            </div>
                        </div>
                    </section>
                    {ifp_article_categorys.map((category, index) => {
                        const slugSelected = category.ifp_article_categorys_articles.map(category => category.ifp_article_categorys_articles_url.replace(`https://www.ehealthinsurance.com/resources/${slug}/`, ''))
                        const selectedPosts = slugSelected.map(slug => {
                            const selectedPost = posts.filter(item=>item.node.slug === slug)[0];
                            if (selectedPost) {
                                return selectedPost;
                            }
                            return;
                        });
                        const type = category.ifp_article_categorys_type;
                        switch (type) {
                            case 'article':
                                return (
                                    <ArticleCategory
                                        title={category.ifp_article_categorys_title}
                                        subTitle={category.ifp_article_categorys_subtitle}
                                        posts={selectedPosts}
                                        key={`category-${index}`}
                                        slug={slug}
                                    />
                                )
                                break;
                            case 'quote':
                                return (
                                    <QuoteWidgetForCategory
                                        fromPage="resources" 
                                        censusPage={categoryName}
                                        key={`category-${index}`}
                                        slug={slug}
                                    />
                                )
                            case 'links':
                                return (
                                    <section className="bg-white border-top" key={`category-${index}`}>
                                        <span data-wa-depth="affordable-health-insurance-by-state:cost nationwide:depthTracking"></span>
                                        <div className="container">
                                            <div className="row justify-content-center text-center">
                                                <div className="col-md-9 col-lg-10 col-xl-9">
                                                    <h2 className="display-4">{category.ifp_article_categorys_title}</h2>
                                                    <div className={`${slug ? categoryAccentClass[slug] : 'null'} mx-auto title-gap`}></div>
                                                    <p className="lead font-weight-light mb-5">{category.ifp_article_categorys_subtitle}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="container container--grid">
                                        <div className="container__row text-center link-list">
                                            <div>
                                                <a
                                                    className="button-tertiary"
                                                    onClick={() => {
                                                        setIsShowAll(true)
                                                    }}
                                                >View all Business Health Insurance Articles</a>
                                            </div>
                                        </div>
                                        </div>
                                    </section>
                                )

                            default:
                                return (
                                    <ArticleCategory
                                        title={category.ifp_article_categorys_title}
                                        subTitle={category.ifp_article_categorys_subtitle}
                                        posts={selectedPosts}
                                        key={`category-${index}`}
                                        slug={slug}
                                    />
                                )
                                break;
                            }
                        }
                        
                    )}
                </>
            )}
                
            
        </SmallBusinessPage>
    )
}

